<script>
export default {
  props: {
    value: {
      type: Array,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    collapseTags: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<template>
  <ElSelect
    :value="value || []"
    class="f-c-select"
    multiple
    :collapse-tags="collapseTags"
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :placeholder="placeholder"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    popper-class="f-c-select-popper"
  >
    <ElOption
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </ElSelect>
</template>
<style lang="scss">
  .f-c-select {
    width: 100%;
    position: relative;
    overflow: hidden;

    &.el-select {
      display: block;
      height: 24px;
    }

    &.el-select .el-input {
      display: flex;
      height: 24px!important;
    }

    .el-input__inner {
      background: none !important;
      border: none;
      height: 24px!important;
      font-size: 16px;
      padding: 0 !important;
      flex-grow: 1;
    }

    .el-input__suffix {
      cursor: pointer;
      position: static;
      display: block;
      height: 24px;
      border-radius: 50%;
      width: 24px;


      .el-select__caret {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .el-select__tags {
      & > span {
        display: flex;
      }

      .el-tag {
        display: block;
        margin: 0 2px 0 0;
        border: none;
        border-radius: 0;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .el-select__input{
      margin-left: 0;
    }
  }

  .el-input.is-disabled .el-input__inner {
    cursor: default;
  }

  .f-c-select-popper {
    &.el-popper {
      margin: 0 !important;

      &[x-placement^=top] {
        border-radius: 4px 4px 0 0;
      }

      &[x-placement^=bottom] {
        border-radius: 0 0 4px 4px;
      }
    }

    .popper__arrow {
      display: none !important;
    }

    .el-select-dropdown__item {
      font-size: 16px;
    }

    .el-scrollbar__bar.is-vertical {
      opacity: 1;
    }
  }
</style>
